module.exports = __webpack_public_path__ + "media/images/emoticons/gasstation-9bd71cdb81e31d9bc850169fe2f0b01b.gif";